/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Checkout_Cancelled_ToastInputs */



/**
* | output |
* | --- |
* | "Checkout was cancelled" |
*
* @param {Signup_Checkout_Cancelled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_checkout_cancelled_toast = /** @type {((inputs?: Signup_Checkout_Cancelled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Checkout_Cancelled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le paiement a ete annule")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Bestellvorgang wurde abgebrochen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il checkout è stato annullato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оформление заказа было отменено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El pago fue cancelado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("退房已取消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チェックアウトはキャンセルされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चेकआउट रद्द कर दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O pedido foi cancelado.")
	return /** @type {LocalizedString} */ ("Checkout was cancelled")
});